module.exports = __webpack_public_path__ + "img/chi-home.661ce942.jpg";